"use client";
import { Check } from "@/components/svg";
import { getQuestionOption, usersPerformance } from "@/services/pricing";
import React, { useEffect, useState } from "react";
import "../app/pricing/price.css";
import { Loading } from "@/components/Loading";
import AboutHeroSection from "@/components/AboutHeroSection";
import price from "../../public/assets/images/packages/price.png";
import { Col, Container, Row } from "react-bootstrap";
import CommonButton from "@/components/CommonButton";
import PackageCard from "@/components/PackageCard";
import "../app/project-price/project-price.css";
import DetailsConformationModal from "@/components/DetailsConformationModal";
import PricingDetailsForm from "../components/PricingDetailsForm";
import { showToast } from "../../utils/libs/toast-utilis";
import { useRouter, useSearchParams } from "next/navigation";
import ProtectedRoute from "@/components/ProtectedRoute";
function PricingCard({ plan, isRecommended = false }) {
  const totalCost = plan?.base_price;

  return (
    // <div
    //   className={`position-relative bg-white rounded-3 p-4 shadow ${
    //     isRecommended
    //       ? "border border-warning shadow-lg"
    //       : "border border-light"
    //   } h-100`}
    // >
    //   {/* Recommended Tag */}
    //   {isRecommended && (
    //     <div className="position-absolute top-0 start-50 translate-middle">
    //       <div className="neo-btn-primary text-white small fw-semibold px-3 py-1 rounded-pill d-flex align-items-center">
    //         <span className="me-1">⚡</span>
    //         Best plan for long term
    //       </div>
    //     </div>
    //   )}

    //   {/* Plan Title */}
    //   <div className="mb-4 mt-3">
    //     <h2 className="h4 fw-bold text-dark mb-2">{plan.title}</h2>
    //     <p className="text-muted small">{plan.description}</p>
    //   </div>

    //   {/* Get Cost Breakdown Button */}
    //   <button className="btn neo-btn-primary fw-semibold w-100 rounded-3 mb-4 py-2">
    //     Get Cost Breakdown
    //   </button>

    //   {/* Pricing */}
    //   <div className="mb-4">
    //     <div className="card-starting-at">Starting at*</div>
    //     <div className="d-flex align-items-baseline">
    //       <span className="display-6 fw-bold text-dark">${totalCost}</span>
    //       <span className="text-muted fs-5 ms-1">/Month</span>
    //     </div>
    //   </div>

    //   {/* Ideal For */}
    //   <div className="mb-4">
    //     <span className="text-dark fw-medium">Ideal for </span>
    //     <span className="card-starting-at">
    //       {plan.complexity || "New Projects"}
    //     </span>
    //   </div>

    //   {/* Features List */}
    //   <div className="card-benefits">
    //     <p className="benefit-item">
    //       <Check className="check" />
    //       Base Price: ${plan.base_price}
    //     </p>
    //     <p className="benefit-item">
    //       <Check className="check" />
    //       Design Cost: ${plan.designCost}
    //     </p>
    //     <p className="benefit-item">
    //       <Check className="check" />
    //       Marketing Cost: ${plan.marketingCost}
    //     </p>
    //     <p className="benefit-item">
    //       <Check className="check" />
    //       Duration: {plan.duration_months} months
    //     </p>
    //     <p className="benefit-item">
    //       <Check className="check" />
    //       Complexity: {plan.complexity}
    //     </p>
    //   </div>
    // </div>
    <div
      className={`pricing-card pricing-card-packages ${
        isRecommended ? "best-plan-responsive" : ""
      }`}
    >
      {isRecommended && (
        <div className="best-plan-inner">Best plan for long term 🚀</div>
      )}
      <div className="card-inner">
        <div>
          <h3 className="card-title">{plan?.title}</h3>
          <p className="card-subtitle">{plan?.description}</p>
          {/* <Link href={`/packages`}> */}
          <CommonButton label="Get Cost Breakdown" className="w-100 mt-3" />
          {/* </Link> */}
        </div>
        <div>
          <p className="card-starting-at">Starting at*</p>
          <div className="card-price">
            ${totalCost}
            <sub className="card-unit">/Month</sub>
          </div>
          <p className="card-ideal">
            <span>Ideal for </span>
            {plan?.complexity || "New Projects"}
          </p>
          <div className="card-benefits">
            <p className="benefit-item">
              <Check className="check" />
              Base Price: ${plan?.base_price}
            </p>
            {/* <p className="benefit-item">
              <Check className="check" />
              Design Cost: ${plan?.designCost}
            </p>
            <p className="benefit-item">
              <Check className="check" />
              Marketing Cost: ${plan?.marketingCost}
            </p> */}
            <p className="benefit-item">
              <Check className="check" />
              Duration: {plan?.duration_months} months
            </p>
            <p className="benefit-item">
              <Check className="check" />
              Complexity: {plan?.complexity}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

const PackagesPage = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  const [selectedPackageName, setSelectedPackageName] = useState(null);
  const [userDetails, setUserDetails] = useState(false);
  const searchParams = useSearchParams();
  const quoteId = searchParams.get("quoteId");
  const route = useRouter();
  // const [customerModalShow, setCustomerModalShow] = useState(false);
  const fetchApi = async () => {
    try {
      setLoading(true);
      const [packageRes] = await Promise.all(
        ["package/getAll"]?.map((item) => getQuestionOption(item))
      );
      setPackages(packageRes);
    } catch (error) {
    } finally {
      setLoading(false);
    }
    const getCustomerDetails = localStorage?.getItem("authDetails");
    const customerDetailsPares = getCustomerDetails
      ? JSON.parse(getCustomerDetails)
      : {};
    setUserDetails(customerDetailsPares);
  };
  useEffect(() => {
    if (quoteId) {
      fetchApi();
    } else {
      route?.push("/pricing");
    }
  }, [quoteId]);
  if (loading) {
    return <Loading />;
  }

  return (
    <ProtectedRoute>
      <AboutHeroSection
        pillText="~ Our All Packages ~"
        title="Flexible Packages"
        highlight="Tailored to Fit Every Business Need"
        description="From startup MVPs to enterprise-grade platforms — explore our curated packages designed to match your goals, budget, and timeline. Whether you're building from scratch or scaling fast, we’ve got a plan that works for you. Clarity. Speed. Affordability. All in one place."
        imageAlt="Affordable Packages"
        image={price}
      />
      <Container className="py-5 packages">
        <Row className="gy-4">
          {packages?.map((plan, index) => (
            <Col xl={4} lg={6} md={6} sm={12} className="d-flex" key={index}>
              <PackageCard
                title={plan?.title}
                description={plan?.description}
                base_price={plan?.base_price}
                monthlyCost={plan?.monthlyCost}
                industry_tags={plan?.industry_tags}
                complexity={plan?.complexity}
                duration_months={plan?.duration_months}
                engagement_type={plan?.engagement_type}
                target_platforms={plan?.target_platforms}
                technical_tags={plan?.technical_tags}
                team_roles={plan?.team_roles}
                idealFor={plan?.idealFor}
                expire_date={plan?.expire_date}
                onHandelSelect={async () => {
                  setShowModal(true);
                  setSelectedPackageId(plan?._id);
                  setSelectedPackageName(plan?.title);
                  try {
                    await usersPerformance({
                      payload: {
                        customStatus: "Interested",
                        packageId: [plan?._id],
                      },
                      leadId: quoteId,
                    });
                  } catch (error) {
                    if (error?.message) {
                      showToast.error(error?.message);
                    }
                  }
                }}
              />
            </Col>
          ))}
        </Row>
        <DetailsConformationModal
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
          details={{
            name: userDetails?.name,
            mobile: userDetails?.mobile_number,
            email: userDetails?.email,
            _id: userDetails?._id,
          }}
          onUpdate={() => {
            fetchApi();
          }}
          quoteId={quoteId}
          selectedPackageId={selectedPackageId}
          selectedPackageName={selectedPackageName}
          // secondBtn={() => setCustomerModalShow(true)}
        />
        {/* <PricingDetailsForm
          modalShow={customerModalShow}
          setModalShow={setCustomerModalShow}
          userRecord={{
            name: userDetails?.name,
            mobile: userDetails?.mobile_number,
            email: userDetails?.email,
            _id: userDetails?._id,
          }}
          isEdit={true}
          onUpdate={() => {
            setCustomerModalShow(false);
            fetchApi();
          }}
        /> */}
      </Container>
    </ProtectedRoute>
  );
};

export default PackagesPage;
